import { useParams } from 'react-router';
import { type ErrorLike } from '@apollo/client';
import { useSuspenseQuery } from '@apollo/client/react';
import { useState } from 'react';

import { type ISoftwareEscrow } from 'src/graphql/schema';
import { SoftwareEscrowDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrow.query';

import { createRequiredContext } from '../createRequiredContext';

type IUiState = {
  isTerminationDialogOpen: boolean;
};

const [useSoftwareEscrow, SoftwareEscrowProvider] = createRequiredContext<{
  softwareEscrow: ISoftwareEscrow;
  error?: ErrorLike;
  ui: IUiState;
  refetch: () => void;
  setIsTerminationDialogOpen: (isOpen: boolean) => void;
}>();

const SoftwareEscrowContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isTerminationDialogOpen, setIsTerminationDialogOpen] = useState(false);
  const { id: escrowId = '' } = useParams();
  const { data, error, refetch } = useSuspenseQuery(SoftwareEscrowDocument, {
    variables: { escrowId },
    skip: !escrowId,
  });

  const providerValue = {
    softwareEscrow: data?.softwareEscrow as ISoftwareEscrow,
    error,
    ui: {
      isTerminationDialogOpen,
    },
    refetch,
    setIsTerminationDialogOpen,
  };

  return <SoftwareEscrowProvider value={providerValue}>{children}</SoftwareEscrowProvider>;
};

export { useSoftwareEscrow, SoftwareEscrowContextProvider };
